import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import AddNewApiOkx from './AddNewApiOkx';
import { buyTokenModalAction } from '../../store/token/tokenActions';
import { Key, X } from 'lucide-react';
import './AddNewApiOkxModal.scss';

function AddNewApiModalOkx({ ...props }) {
  const { buyTokenModal, buyTokenModalRequest } = props;

  const handleClose = () => {
    buyTokenModalRequest(false);
  };

  return (
    <Modal 
      show={buyTokenModal} 
      onHide={handleClose} 
      size="md" 
      centered
      className="modern-api-modal okx-modal"
    >
      <Modal.Header className="modern-modal-header">
        <Modal.Title className="modal-title">
          <Key size={24} className="title-icon" />
          Add OKX API Key
        </Modal.Title>
        <button 
          className="modern-close-btn"
          onClick={handleClose}
        >
          <X size={20} />
        </button>
      </Modal.Header>
      <Modal.Body className="modern-modal-body">
        <AddNewApiOkx handleClose={handleClose} />
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    buyTokenModal: state.tokenReducer.buyTokenModal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    buyTokenModalRequest: (payload) => {
      dispatch(buyTokenModalAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewApiModalOkx);